// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1205": "21b273d5eab8","2281": "4c2b1a89769c","3636": "dbfc89bc969b",}[chunkId] + ".css"
}